export const getInitials = ({
  value,
  useSingleInitial = false,
  showSpecialCharacters = false,
}) => {
  if (!value) return "";

  const [firstName = "", lastName = ""] = (() => {
    const splitValue = value.trim().split(/\s+/);

    if (showSpecialCharacters) {
      return splitValue;
    }

    return splitValue
      .map(word => word.replace(/[^a-zA-Z0-9]/g, ""))
      .filter(word => word !== "");
  })();

  const firstInitial = firstName.charAt(0);
  if (useSingleInitial) return firstInitial.toUpperCase();

  const lastInitial = lastName.charAt(0);

  return `${firstInitial.toUpperCase()}${lastInitial}`;
};
